import { DEFAULT_LOCALE, isLocale, type Locale } from "./locales";

// Язык до входа: первый поддерживаемый из настроек браузера.
// После входа язык берётся из профиля пользователя.
export const detectLocale = (languages: readonly string[] = navigator.languages): Locale => {
  for (const language of languages) {
    const base = language.toLowerCase().split("-")[0] ?? "";
    if (isLocale(base)) {
      return base;
    }
  }
  return DEFAULT_LOCALE;
};
